/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnInit} from '@angular/core';
import {PagePermissionType} from "../../models/page-permission-type";
import {PagePermissionService} from "../../services/page-permission.service";

@Component({
  selector: 'app-infrastructure-header',
  templateUrl: './infrastructure-header.component.html'
})
export class InfrastructureHeaderComponent {
  pagePermissionType = PagePermissionType;

  @Input()
  title: string;


  constructor(
    public pagePermissionService: PagePermissionService
  ) { }


}
